import Component from 'gia/Component';

import { gsap } from 'gsap';

export default class HomeReviews extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      reviews: []
    };
  }

  mount() {
    let that = this;
// cycle through the reviews and add the 'block' class to the first one
    this.ref.reviews[0].classList.remove('hidden');
    this.ref.reviews[0].classList.add('inline-flex');


    // change visible review every 5 seconds
    setInterval(function() {

      // get the current visible review
      let currentReview = that.ref.reviews.find(review => review.classList.contains('inline-flex'));
      console.log(currentReview);
      // get the next review
      let nextReview = currentReview.nextElementSibling;

      // if there is no next review, go back to the first one
      if (!nextReview) {
        nextReview = that.ref.reviews[0];
      }

      // add 'block' class to the next review
      // currentReview.classList.remove('inline-flex');
      // currentReview.classList.add('hidden');
      gsap.to(currentReview, {
        opacity: 0,
        onComplete: function() {
          currentReview.classList.add('hidden');
          currentReview.classList.remove('inline-flex');
          gsap.fromTo(nextReview,{opacity:0}, {
            opacity: 1,
            onStart: function() {
              nextReview.classList.remove('hidden');
              nextReview.classList.add('inline-flex');
            }
          })
        }
      })
      // nextReview.classList.remove('hidden');

    }, 5000);
  }

}